import { subscribe, activateScripts } from '@zalando-internal/zalando-consent-api';
// listen to the consent changes
// this allows us to still activate the script later when the user gives the consent
export const subscribeToConsentChange = () => {
    const callback = (consent) => {
        if (consent.status) {
            activateScripts()
                .catch(() => console.error('[Sentry] An error has occurred activating scripts'));
        }
    };
    subscribe('sentry_analytical_lounge', callback);
};
//# sourceMappingURL=consent.js.map